import React, { useEffect } from 'react';
import { EditorContent, useEditor } from '@tiptap/react';
import TiptapMenu from './TiptapMenu';
import StarterKit from '@tiptap/starter-kit';
import Color from '@tiptap/extension-color';
import { TextStyle } from "@tiptap/extension-text-style";
import { Underline } from "@tiptap/extension-underline";
import { Document } from "@tiptap/extension-document";
import Link from '@tiptap/extension-link';
import Paragraph from "@tiptap/extension-paragraph";
import Code from '@tiptap/extension-code';


const TiptapForm = ({ onChange, content }) => {

    const editor = useEditor({
        extensions: [
            Document,
            StarterKit,
            Color,
            TextStyle,
            Underline,
            Code,
            Paragraph,
            Link.configure({
                HTMLAttributes: {
                    class: 'link',
                },
            }),
        ],
        content: content || '',
        editable: true,
        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        },
    });

    useEffect(() => {
        if (editor && content !== undefined) {
            if (editor.getHTML() !== content) {
                editor.commands.setContent(content || '');
            }
        }
    }, [content, editor]);

    if (!editor) {
        return null;
    }

    return (
        <div className="tiptap-form">
            <TiptapMenu editor={editor} content={content} />
            <EditorContent editor={editor} />
        </div>
    );
};

export default TiptapForm;